import React from 'react';
import { ENGAGEMENT_STATUS } from '../lib/status';

/** Engagement status pill. */
export default function StatusPill({ status }) {
  const s = ENGAGEMENT_STATUS[status] || ENGAGEMENT_STATUS.archived;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px',
      background: s.bg, color: s.fg,
      fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-xs)',
      letterSpacing: 'var(--track-eyebrow)', textTransform: 'uppercase',
      borderRadius: 'var(--radius-pill)', lineHeight: 1,
    }}>
      {s.live && (
        <span style={{
          width: 6, height: 6, borderRadius: 999, background: 'var(--science-500)',
          animation: 'cc-pulse 1.8s var(--ease-out) infinite',
        }} />
      )}
      {s.label}
    </span>
  );
}
